/* eslint-disable */
export default {
  _IntroNewspaper: 'IntroNewspaper',
  _Title: 'Title',
  _tailMask: 'tailMask',
}